import { render, staticRenderFns } from "./BundleListCardItem.vue?vue&type=template&id=c068daac&scoped=true"
import script from "./BundleListCardItem.vue?vue&type=script&lang=js"
export * from "./BundleListCardItem.vue?vue&type=script&lang=js"
import style0 from "./BundleListCardItem.vue?vue&type=style&index=0&id=c068daac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c068daac",
  null
  
)

export default component.exports